// componente utilizzata per mostrare la pagina di gestione pannelli; la prima e unica funzione richiamata è la lettura
// dei pannelli mediante apposito servizio di back-end

import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../service/authentication.service';

@Component({
  selector: 'registries',
  templateUrl: './registries.component.html',
  styleUrls: ['./style.scss']
})

export class RegistriesTabComponent implements OnInit {
  user
  constructor(private authenticationService: AuthenticationService) { }

  ngOnInit() {
    this.user = this.authenticationService.user;
  }
}
